module.exports = __webpack_public_path__ + "static/media/icMenuCheck.cdad937a.svg";